import { BrandLogo } from './BrandLogo';
import { CornerButtons } from './CornerButtons';
import { Flex, Spacer } from '@chakra-ui/react';
import type { NavConfig, NavItem } from './navigationData';
import { NavTabs } from './NavTabs';
import { Socials } from './Socials';

type DesktopHeaderProps = {
    config: NavConfig;
    navItems: NavItem[];
    activeTab: string;
    user: any;
    userLoading: boolean;
    isAdmin: boolean;
    locationPathname: string;
    navigate: (path: string) => void;
    handleLogout: () => Promise<void>;
};

export function DesktopHeader({
    config,
    navItems,
    activeTab,
    user,
    userLoading,
    isAdmin,
    locationPathname,
    navigate,
    handleLogout,
}: DesktopHeaderProps) {
    return (
        <>
            <Flex px={4} alignItems="center">
                <BrandLogo />
                <Socials />
                <Spacer />

                <CornerButtons
                    user={user}
                    userLoading={userLoading}
                    config={config}
                    isAdmin={isAdmin}
                    locationPathname={locationPathname}
                    navigate={navigate}
                    handleLogout={handleLogout}
                />
            </Flex>

            {config.showTabs && (
                <Flex alignItems="center" bg="white" minH="40px" gap={4} flexWrap="wrap">
                    <NavTabs
                        navItems={navItems}
                        activeTab={activeTab}
                        size="md"
                        display={{ base: 'none', lg: 'flex' }}
                        justifyContent={config.tabsAlign}
                    />
                </Flex>
            )}
        </>
    );
}
